import { useEffect } from 'react';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";

const Unauthenticated = () => {
  const { instance } = useMsal();

  useEffect(() => {
    if(!window.location.href.endsWith('signout')) {
      instance.loginRedirect(loginRequest);
    }
  }, [instance]);

  return (
    <>
    <div className="flex flex-col my-8">
      <div className="
      bg-cod-gray-light border-t-4 border-b-4 border-utrgv-orange
      text-2xl font-semibold text-utrgv-orange py-8 px-12">CS @ UTRGV</div>
      {!window.location.href.endsWith('signout') ?
      <div className="text-center pt-4 italic">Signing in...</div>
      :
      <>
        <div className="text-center pt-4 pb-2">You are signed out.</div>
        <div className="text-center pt-2 pb-4">
          <a href="/" className="
              inline-block
              text-white
              border rounded border-white 
              px-4 py-2 m-2 leading-none
              hover:bg-utrgv-blue hover:text-white">Sign In</a>
        </div>
      </>}
    </div>
    </>
  );
}

export default Unauthenticated;
